import { useState } from "react";
import { useAuth } from "../lib/auth.js";
import { Button } from "./ui.js";

/** Prominent bar while an Admin is viewing the app as another user. */
export function ImpersonationBanner(): JSX.Element | null {
  const { user, impersonatedBy, stopImpersonating } = useAuth();
  const [busy, setBusy] = useState(false);

  if (!user || !impersonatedBy) return null;

  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 bg-amber-500 px-4 py-2 text-sm font-medium text-amber-950"
    >
      <span>
        Viewing as <strong>{user.name || user.email}</strong>
        <span className="font-normal"> ({user.email})</span>
        {" — "}
        you are <strong>{impersonatedBy}</strong>
      </span>
      <Button
        variant="secondary"
        disabled={busy}
        onClick={() => {
          setBusy(true);
          void stopImpersonating().finally(() => setBusy(false));
        }}
      >
        Stop impersonating
      </Button>
    </div>
  );
}
